import { useCategoryTreeItem } from '../categoryTree';
import { KuxFilteredCategoriesDTO, tvpil } from '../compat/tvpil';
import { RhinoImageRatio } from '../image';

import { useRailSettings } from './useRailSettings';
import { getChannelIconSettings } from './utils/getChannelIconSettings';

type UseHeroSettingsProps = {
  defaultImageRatio?: RhinoImageRatio;
  defaultLandscapeImageHeight?: number;
  defaultPortraitImageHeight?: number;
  imageSize?: 'default' | 'medium' | 'compact';
  referenceId: string;
};

export type HeroSettings = {
  branding: KuxFilteredCategoriesDTO['uiDesignElements'];
  channelIconType: number | undefined;
  channelIconRatio: RhinoImageRatio;
  id: number;
  imageHeight: number | undefined;
  imageType: number | undefined;
  imageWidth: number | undefined;
  shouldShowFavoriteIndicator: boolean;
  shouldShowCurrentProgram: boolean;
  title: string;
};

export const useHeroSettings = ({
  referenceId,
  imageSize,
  defaultPortraitImageHeight,
  defaultLandscapeImageHeight,
  defaultImageRatio,
}: UseHeroSettingsProps): HeroSettings | undefined => {
  const category = useCategoryTreeItem(referenceId);

  const railSettings = useRailSettings({
    referenceId,
    imageSize,
    defaultPortraitImageHeight,
    defaultLandscapeImageHeight,
    defaultImageRatio,
  });

  if (!category || !railSettings) {
    return undefined;
  }

  const { branding, imageHeight, imageType, imageWidth, title } = railSettings;

  const channelIconSettings = getChannelIconSettings(category.railImageProperty.channelPresentationImageType);
  const shouldShowFavoriteIndicator =
    tvpil.rootStore.isFavoriteChannelPersonalization && Boolean(category.railProperty.presentFavoriteIndicator);

  return {
    branding,
    channelIconRatio: channelIconSettings.channelIconRatio,
    channelIconType: channelIconSettings.channelIconType,
    id: railSettings.id,
    imageHeight,
    imageType,
    imageWidth,
    shouldShowFavoriteIndicator,
    shouldShowCurrentProgram: category.railProperty.presentCurrentPrograms,
    title,
  };
};
